import { status } from '../utils';

export function getGroups(token){

  return fetch(`${process.env.REACT_APP_API_URL}/groups/`,{
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Token ${token}`
    },
  })
  .then(status).catch( e => {console.log(e)})
}

export function getGroup(id, token){
  return fetch(`${process.env.REACT_APP_API_URL}/groups/${id}/`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Token ${token}`
    },
  })
  .then(status).catch( e => {console.log(e)})
}

export function joinGroup(data){
  return fetch(`${process.env.REACT_APP_API_URL}/members/join/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
  .then(status).catch( e => {console.log(e)})
}

export function leaveGroup(data){
  return fetch(`${process.env.REACT_APP_API_URL}/members/leave/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
  .then(status).catch( e => {console.log(e)})
}


export function postComment(token, description, group, user){
  return fetch(`${process.env.REACT_APP_API_URL}/comments/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Token ${token}`
    },
    body: JSON.stringify({description, group, user})
  })
  .then(status).catch( e => {console.log(e)})
}